import { render, staticRenderFns } from "./IssueResult.vue?vue&type=template&id=7ae01b5f&"
import script from "./IssueResult.vue?vue&type=script&lang=ts&"
export * from "./IssueResult.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports